import React,{Component} from 'react';
import moment from 'moment'
import {formatPrice} from '../helpers/helpers'

class ReportsCustomDisplay extends Component{
     constructor(){
        super();        
        this.range = this.range.bind(this)
        
    }
    
    range(e){
    	e.preventDefault();
    	this.props.range(this.daterange1.value,this.daterange2.value)
    }     
    render() {

        return (
            <form  className="form-horizontal form-bordered" onSubmit={this.range}>
	            <fieldset>
	                <div className="form-group">
	                    <label className="col-md-4 control-label" htmlFor="example-daterange1">Select Date Range</label>
	                    <div className="col-md-8">
	                        <div className="input-group input-daterange" data-date-format="mm/dd/yyyy">
	                            <input type="text" id="example-daterange1" name="daterange1" ref={(input)=>this.daterange1 = input} className="form-control text-center" placeholder="From" />
	                            <span className="input-group-addon"><i className="fa fa-angle-right"></i></span>
	                            <input type="text" id="example-daterange2" name="daterange2" ref={(input)=>this.daterange2 = input}className="form-control text-center" placeholder="To" />
	                        </div>
	                    </div>
	                </div>
	            </fieldset>
	            <div className="form-group form-actions">
	                <div className="col-md-8 col-md-offset-4">
	                    <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-angle-right"></i> Submit</button>
	                    <button type="reset" className="btn btn-sm btn-warning"><i className="fa fa-repeat"></i> Reset</button>
	                </div>
	            </div>
	        </form>
        );
    }
}

export default  ReportsCustomDisplay;



// WEBPACK FOOTER //
// ./src/components/ReportsCustomDisplay.js